import { render, staticRenderFns } from "./HLSVideo.vue?vue&type=template&id=870feadc&scoped=true&"
import script from "./HLSVideo.vue?vue&type=script&lang=ts&"
export * from "./HLSVideo.vue?vue&type=script&lang=ts&"
import style0 from "./HLSVideo.vue?vue&type=style&index=0&id=870feadc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870feadc",
  null
  
)

export default component.exports